import React from "react";
import "./styles/atoms.css";
import "./styles/Section.css";

/**
 * Section wrapper. `intro` applies the slightly tighter padding the
 * intro block uses; everything else is a plain section.
 *
 * <Section>…</Section>
 */
export function Section({ children, intro = false, className = "", ...rest }) {
  const classes = [
    "rs-section",
    intro ? "rs-section--intro" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={classes} {...rest}>
      <div className="container">{children}</div>
    </section>
  );
}

/**
 * H2 + optional subtitle, with an optional right-aligned action
 * (the landing page's "Alle ansehen" button lives in `action`).
 */
export function SectionHead({ title, subtitle, kicker, action }) {
  if (!title && !subtitle && !kicker) return null;

  return (
    <div className={`rs-section-head ${action ? "rs-section-head--cta" : ""}`}>
      <div>
        {kicker && <p className="rs-kicker">{kicker}</p>}
        {title && <h2>{title}</h2>}
        {subtitle && <p>{subtitle}</p>}
      </div>
      {action || null}
    </div>
  );
}

export default Section;